/** @jsx jsx */
import { jsx } from '@emotion/react';

type Props = {
  className?: string;
  width?: number;
  height?: number;
};

const AdobeLogoSvg = ({ className, width = 61, height = 54 }: Props) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 61 54"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M0 53.2576L22.3404 0H37.9973L60.1714 53.2576H43.5616L29.5741 17.8826L20.3513 41.0928H31.3201L35.6884 53.2576H0Z"
      fill="#EB1000"
    />
  </svg>
);

export default AdobeLogoSvg;
